var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarRename(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5206 2.23022C6.32794 1.76701 5.67176 1.76701 5.4791 2.23022L4.38062 4.87128L1.52937 5.09986C1.0293 5.13995 0.826525 5.76402 1.20753 6.09039L3.37988 7.95124L2.71619 10.7336C2.59979 11.2216 3.13065 11.6073 3.55878 11.3458L5.99985 9.85476L8.44091 11.3458C8.86905 11.6073 9.39991 11.2216 9.28351 10.7336L8.61982 7.95124L10.7922 6.09039C11.1732 5.76402 10.9704 5.13995 10.4703 5.09986L7.61908 4.87128L6.5206 2.23022Z",
    fill: "#228B22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRename);
export default __webpack_public_path__ + "static/media/starRename.9b852b040991f4d2f1c4d489712f473c.svg";
export { ForwardRef as ReactComponent };